import React, { useEffect, useState } from 'react';

import Carousel from './Carousel';
import HomeContent from './HomeContent';
import HomeContent1 from './Homecont1';
import HomeCont2 from './Homecont2';
import HomeCont3 from './Homecont3';
import HomeCont4 from './Homecont4';
import ReviewSlider from './Slider';
import Footer from './Footer';
import Navbar from './Navbar';
import EnrollForm from './Enroll'; 

import '../Css_files/icon.css'; // External CSS
import Hero from './About_c1';
import HomeCont5 from './Homecont5';
import Testimonials from './Slider';
import TestimonialSlider from './Slider';

const Full_Homepage = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showForm, setShowForm] = useState(false); // ✅ Control form visibility

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);

    // ✅ Show enroll form after 3 seconds
    const timer = setTimeout(() => setShowForm(true), 3000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Navbar onEnrollClick={() => setShowForm(true)} /><br></br><br></br>
      <Carousel/>
      <HomeContent />
      <HomeContent1 />
      <HomeCont2 />
      <HomeCont5/>
       <HomeCont3 />
      <HomeCont4 />
      {/* <ReviewSlider /> */}
      <TestimonialSlider/>
      <Footer />

      {/* Floating WhatsApp Icon */}
      <a
        href="https://wa.me/9944897638"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default Full_Homepage;
